import React, { useState } from 'react';

import IconSvgComponent from 'shared/ui/icons/IconSvgComponent';

import { DebounceInput } from 'react-debounce-input';
import { SearchBox } from '../../styles/components/PageList';
import { useSelector } from 'react-redux';

const SearchBoxOrgSubscription = ({
  searchText,
  searchChangeHandler,
  filterChangeHandler,
  subscriptionPage,
  deleteOrder,
  tab,
  onKeyDownHandler,
}) => {
  const { selectedAccount, stackSelection, searchTextSubscription, searchTextGlobalSubsId } = useSelector(
    (state) => state.subscription
  );

  const isDeleteTab = tab === 'delete';
  const isDeleteOrder = isDeleteTab && deleteOrder;
  const isOrgSearch = isDeleteTab && !deleteOrder;

  // Placeholder logic
  let placeHolder = 'Search';

  if (subscriptionPage) {
    if (isDeleteOrder) {
      placeHolder = 'Please enter subscription ID';
    } else if (isOrgSearch) {
      placeHolder = 'Please enter organization ID';
    } else {
      placeHolder = 'Search by organization ID or WIM ID';
    }
  }

  // Disabled logic
  const isSearchDisabled =
    subscriptionPage &&
    (!selectedAccount ||
      !stackSelection ||
      searchTextSubscription === '' ||
      (isDeleteTab && searchTextGlobalSubsId === ''));

  return (
    <SearchBox>
      <DebounceInput
        type="text"
        className={`search ${isOrgSearch && !searchText ? 'input-border' : ''}`}
        placeholder={placeHolder}
        onKeyDown={onKeyDownHandler}
        value={searchText}
        onChange={searchChangeHandler}
      />

      {/* Reset button */}
      {searchText && (
        <button
          className={`Search-box-button ${isOrgSearch ? 'input-border' : ''}`}
          onClick={() =>
            filterChangeHandler({
              search_key: '',
              subId: isDeleteOrder,
              type: 'clear',
            })
          }
        >
          <IconSvgComponent svgFileName="searbox-close" title="Reset" alt="SearboxClose" />
        </button>
      )}

      {/* Search button */}
      {(isDeleteOrder || tab === 'view') && (
        <button
          type="button"
          className="searchButton"
          onClick={() =>
            filterChangeHandler({
              search_key: searchText,
              search: true,
            })
          }
          disabled={isSearchDisabled}
        >
          <IconSvgComponent className="search-icon" svgFileName="searchbox" title="Search" alt="Search" />
        </button>
      )}
    </SearchBox>
  );
};

export default SearchBoxOrgSubscription;
